import {Criteria, CriteriaTypeMap, Filter} from '../types';

export function filtersToEntries(filters: Filter[]): [Criteria, CriteriaTypeMap[Criteria]][] {
  return filters
    .filter(({value}) => value !== null && value !== undefined && value !== '')
    .map(({key, value}) => [key, value]);
}
